import React from "react";
import { Col, Row } from "react-bootstrap";
import { DataGrid } from "@mui/x-data-grid";
import Langs, { Localize } from "../../../app/lang/langs";
import ImageButton from "../../buttons/ImageButton";
import addIcon from '../../../assets/images/addIconGray.png';
import addIconFocus from '../../../assets/images/addIconOrange.png';
import deleteIcon from '../../../assets/images/delete.png';
import deleteIconFocus from '../../../assets/images/delete-orange.png';
import { useDispatch } from "react-redux";
import { setAddMembersModalVisibility, setAddMembersMode } from "../vcompSlice";
import TabNavigationButtons from "./TabNavigationButtons";

/**
 * ManagersTab - Renders the project managers DataGrid (case 5).
 * Allows adding and removing managers. At least one manager must remain.
 */
export default function ManagersTab({
    isMobile,
    mode,
    activeIndex,
    setActiveIndex,
    mangersList,
    dtManagers,
    onConfirmDeleteManager,
    onClose,
}) {
    const dispatch = useDispatch();

    const columns = [
        {
            field: 'nom',
            headerName: Localize('nom'),
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'prenom',
            headerName: Localize('prenom'),
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'actions',
            headerName: '',
            width: 70,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                if (mangersList.length > 1) {
                    return (
                        <ImageButton
                            image={deleteIcon}
                            imageFocus={deleteIconFocus}
                            onClick={() => {
                                onConfirmDeleteManager(params.row.id);
                            }}
                            active={true}
                            width={32}
                        />
                    );
                }
                return null;
            },
        },
    ];

    return (
        <div>
            <div
                className={`card p-3 m-4 d-flex align-content-center border-0`}
                style={isMobile === 2 ? { height: '85%', display: 'flex', flexDirection: 'column' } : {}}
            >
                <Row className='d-flex justify-content-between align-items-center w-100 mb-4 mt-2 ps-2'>
                    <Col lg={4} xs={8} className="d-flex my-auto align-items-center">
                        <Langs str="EDIT_PROJECT_MANAGERS" />
                    </Col>
                    <Col lg={4} xs={4} className="d-flex justify-content-end pe-4">
                        <ImageButton
                            image={addIcon}
                            imageFocus={addIconFocus}
                            onClick={() => {
                                dispatch(setAddMembersModalVisibility(true));
                                dispatch(setAddMembersMode("managers"));
                            }}
                            active={true}
                            width={32}
                        />
                    </Col>
                </Row>
                <Row className='d-flex justify-content-between w-100 mb-4 mt-2 ps-2'>
                    <Langs str={"Total"} />: {mangersList.length}
                </Row>
                <DataGrid
                    rows={mangersList}
                    columns={columns}
                    getRowId={(row) => row.id}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    hideFooter
                    density="comfortable"
                    sx={{
                        height: isMobile === 2 ? "calc(90vh - 300px)" : "calc(100vh - 300px)",
                        border: 'none',
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                            borderRadius: '8px 8px 0 0',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        },
                        '& .MuiDataGrid-cell': {
                            borderColor: 'rgba(0, 0, 0, 0.06)',
                        },
                    }}
                />
                {isMobile === 2 && (
                    <TabNavigationButtons
                        isMobile={isMobile}
                        mode={mode}
                        onPrevious={mode !== "edit" ? () => { setActiveIndex(activeIndex - 1) } : null}
                        onNext={onClose}
                        nextLabel={mode === "edit" ? <Langs str="Save & Exit" /> : <Langs str="Next" />}
                    />
                )}
            </div>
            {isMobile !== 2 && (
                <TabNavigationButtons
                    isMobile={isMobile}
                    mode={mode}
                    onPrevious={mode !== "edit" ? () => { setActiveIndex(activeIndex - 1) } : null}
                    onNext={onClose}
                    nextLabel={<Langs str="Save & Exit" />}
                />
            )}
        </div>
    );
}
